import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { GroupInviteLinkShowRouteModel } from 'invite-sign/routes/group-invite/show';

export default class GroupInviteLinkShowExpiredRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    const { groupInviteLink } = <GroupInviteLinkShowRouteModel>this.modelFor('group-invite.show');

    // If the link is active and not expired, redirect back to the fill route
    if (groupInviteLink && !groupInviteLink.isInactiveOrExpired) {
      void this.router.replaceWith('group-invite.show.fill');
    }
  }
}
